import { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import headerImg from "../assets/img/header-img.webp";
import { ArrowRightCircle } from 'react-bootstrap-icons';
import 'animate.css';
import TrackVisibility from 'react-on-screen';
import { stats } from "../data/content";

const toRotate = [ "Desenvolvedor Backend", "Desenvolvedor Full-Stack", "Engenheiro de Software" ];
const period = 2000;

export const Banner = () => {
  const [loopNum, setLoopNum] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);
  const [text, setText] = useState('');
  const [delta, setDelta] = useState(300 - Math.random() * 100);

  useEffect(() => {
    let ticker = setInterval(() => {
      tick();
    }, delta);

    return () => { clearInterval(ticker) };
  }, [text])

  const tick = () => {
    let i = loopNum % toRotate.length;
    let fullText = toRotate[i];
    let updatedText = isDeleting ? fullText.substring(0, text.length - 1) : fullText.substring(0, text.length + 1);

    setText(updatedText);

    if (isDeleting) {
      setDelta(prevDelta => prevDelta / 2);
    }

    if (!isDeleting && updatedText === fullText) {
      setIsDeleting(true);
      setDelta(period);
    } else if (isDeleting && updatedText === '') {
      setIsDeleting(false);
      setLoopNum(loopNum + 1);
      setDelta(500);
    }
  }

  return (
    <section className="banner" id="home">
      <Container>
        <Row className="align-items-center">
          <Col xs={12} md={6} xl={7}>
            <TrackVisibility once>
              {({ isVisible }) =>
              <div className={isVisible ? "animate__animated animate__fadeIn" : ""}>
                <span className="tagline">Backend & Full-Stack Developer</span>
                <h1>Oi! Eu sou o Pedro Pampolini<br/><span className="txt-rotate" aria-hidden="true"><span className="wrap">{text}</span></span></h1>
                <p>
                  Desenvolvedor de software em Belo Horizonte, formado em Ciência da Computação pela PUC Minas.
                  Construo sistemas distribuídos e escaláveis com TypeScript, NestJS e AWS, incluindo
                  serviços usados por mais de 8 milhões de pessoas, com picos de 200 mil requisições por segundo.
                </p>
                <div className="banner-actions">
                  <a href="#projetos" className="connect-link">
                    <button>Ver projetos <ArrowRightCircle size={25} /></button>
                  </a>
                  <a href="#contato" className="connect-link secondary">
                    <button>Entre em contato</button>
                  </a>
                </div>
              </div>}
            </TrackVisibility>
          </Col>
          <Col xs={12} md={6} xl={5}>
            <img src={headerImg} alt="Foto de Pedro Pampolini Mendicino" width="640" height="640"/>
          </Col>
        </Row>
        <Row className="stats">
          {stats.map((stat) => (
            <Col xs={6} lg={3} key={stat.label}>
              <div className="stat">
                <span className="stat-value">{stat.value}<small>{stat.unit}</small></span>
                <span className="stat-label">{stat.label}</span>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  )
}
